module.exports = __webpack_public_path__ + "img/MM_logo_nav2.d3f04963.png";